import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import Button from '../../components/Button';
import Input from '../../components/Input';
import regex from '../../../utils/regex';
import { usersApi } from '../../../services/users';
import { analyticsApi } from '../../../services/analytics';

const ForgotPassword = () => {
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');

  const [emailSent, setEmailSent] = useState<boolean>(false);

  useEffect(() => {
    analyticsApi.logEvent(
      '',
      'View',
      {},
      'ForgotPassword'
    );
  }, []);

  const forgotPassword = async () => {
    validate();
    try {
      const response = await usersApi.forgotPassword(email);
      if(!response.data.error) {
        setEmailSent(true);
        setEmailError('')
      } else {
        setEmailError(response.data.message)
      }
    } catch (e) {
      console.log(e);
    }
  };

  const validate = () => {
    if (!regex.email.test(email)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  if (!emailSent) {
    return (
      <>
        <div className={styles.body}>
          <div className={'w100'}>
            <h1 className={`scene_title`}>Recover Password</h1>
            <h3 className={`scene_title`}>
              Enter your email to reset your password
            </h3>
          </div>
          <div className={'w100'}>
            <Input
              hasError={!!emailError}
              errorMessage={emailError}
              value={email}
              onChange={setEmail}
              type={'text'}
              placeholder={'Enter email'}
              label={'Your email'}
            />
          </div>
          <Button type={'default'} onClick={forgotPassword}>
            Submit
          </Button>
        </div>
        <div className={styles.footer}>
          By continuing you agree to our <br />
          <a href="https://myorganicapps.com/en/terms.html" target="_blank">
            Terms of Service
          </a>{' '}
          |{' '}
          <a href="https://myorganicapps.com/en/privacy.html" target="_blank">
            Privacy Policy
          </a>{' '}
          |{' '}
          <a
            href="https://myorganicapps.com/en/money-back-policy.html"
            target="_blank"
          >
            Money Back Policy
          </a>{' '}
          <br />
          2021. All rights reserved.
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className={styles.forgot_password}>
          <svg
            width="65"
            height="63"
            viewBox="0 0 65 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 31.482C0 48.8399 14.1241 62.9635 31.482 62.9635C48.8399 62.9635 62.9635 48.8399 62.9635 31.482C62.9635 30.446 62.9147 29.4214 62.8178 28.4111C62.703 27.232 61.6586 26.3731 60.4737 26.4821C59.2946 26.5963 58.4305 27.6439 58.5447 28.8261C58.6275 29.6987 58.6705 30.5859 58.6705 31.482C58.6705 46.4728 46.4728 58.6705 31.482 58.6705C16.4906 58.6705 4.29297 46.4728 4.29297 31.482C4.29297 16.4906 16.4906 4.29297 31.482 4.29297C36.6936 4.29297 41.7648 5.77812 46.1437 8.59171C47.1425 9.23262 48.4679 8.94387 49.1114 7.94504C49.7528 6.94621 49.4609 5.61828 48.4647 4.97685C43.3904 1.71991 37.5179 0 31.482 0C14.1241 0 0 14.1241 0 31.482Z"
              fill="#86C4B9"
            />
            <path
              d="M28.9355 42.9824C29.3532 43.4027 29.9029 43.6118 30.4521 43.6118C31.0018 43.6118 31.551 43.4027 31.9718 42.9851L63.4538 11.5031C64.2923 10.6646 64.2923 9.30522 63.4538 8.46674C62.6153 7.62827 61.256 7.62827 60.417 8.46674L30.4552 38.429L19.0929 27.0667C18.2544 26.2282 16.8951 26.2282 16.0566 27.0667C15.2181 27.9051 15.2181 29.2645 16.0566 30.1035L28.9355 42.9824Z"
              fill="#86C4B9"
            />
          </svg>
          <div className={styles.forgot_password_title}>
            Recovery email sent
          </div>
          <div className={styles.forgot_password_secondary_title}>
            An email has been sent to <span>{ email }</span>. Please check
            your email (and spam)
          </div>
          <div className={styles.footer_group}>
            <div className={styles.didnt_get}>Didn’t get recovery email?</div>

            <a href="#" className={styles.forgot_password_link} onClick={forgotPassword}>
              SEND AGAIN
            </a>
            <a href="#" className={styles.forgot_password_link} onClick={() => {setEmailSent(false)}}>
              CHANGE EMAIL
            </a>
          </div>
        </div>
      </>
    );
  }
};

export default ForgotPassword;
